import type { FaqItem } from '../../content/types'
import { Eyebrow } from '../layout/Eyebrow'
import { Section } from '../layout/Section'

/**
 * FAQ accordion on native `<details>`: works without JS, every answer is in
 * the prerendered HTML (the same items feed the page's FAQPage JSON-LD).
 * The shared `name` makes the group exclusive where the browser supports
 * it — opening one question closes the others — and is ignored elsewhere.
 * Reused by the service pages with their own items.
 */
export function Faq({ items, title, eyebrow }: { items: readonly FaqItem[]; title: string; eyebrow: string }) {
  return (
    <Section id="faq">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2 className="vc2-display mt-4 text-4xl md:text-5xl">{title}</h2>
      <div className="mt-10 divide-y divide-vc2-hairline">
        {items.map((f, i) => (
          <details key={i} name="vc2-faq" className="group py-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-6 vc2-display text-xl [&::-webkit-details-marker]:hidden">
              {f.q}
              <span aria-hidden="true" className="shrink-0 transition-transform group-open:rotate-45">
                +
              </span>
            </summary>
            <p className="mt-4 max-w-3xl text-vc2-ink-soft">{f.a}</p>
          </details>
        ))}
      </div>
    </Section>
  )
}
